<template>


    <!-- preloader start -->
    <div id="pre-load">
        <div id="loader" class="loader">
            <div class="loader-container has-theme-blue">
                <div class="loader-icon"><img src="assets/images/favicon-blue.png" alt=""></div>
            </div>
        </div>
    </div>
    <!-- preloader end -->

    <!-- preloader start -->

    <div id="rs-mouse">
        <div id="cursor-ball"></div>
    </div>

    <!-- preloader end -->

    <!-- Header area start -->
    <header>
        <div class="rs-header-area rs-header-one has-theme-blue rs-sticky" id="header-sticky">
            <div class="container-fluid g-0">
                <div class="header-top">
                    <div class="row justify-content-center justify-content-lg-between align-items-center gy-2">
                        <div class="col-auto d-none d-lg-block">
                            <div class="header-links">
                                <ul>
                                    <li class="d-none d-xl-inline-block"><i
                                            class="bi bi-geo-alt-fill"></i>北京市西城区新街口外大街28号C座302室 </li>
                                    <li class="d-none d-xl-inline-block">&nbsp; <i class="bi bi-telephone-fill"></i><a
                                            href="tel:4006988915">400-6988-915</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="header-links header-right">
                                <ul>
                                    <li>
                                        <a href="http://smartsentry.datascore.cn:8100/" class="ptrk" target="_blank"><i
                                                class="bi bi-globe"></i>智能哨兵云平台入口</a>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-header-inner">
                    <div class="rs-header-left">
                        <div class="rs-header-logo-wrapper">
                            <div class="rs-header-logo">
                                <a href="index"><img src="assets/images/logo/logo.png" alt="logo"></a>
                            </div>
                        </div>
                    </div>
                    <div class="rs-header-menu">

                        <nav id="mobile-menu" class="main-menu">
                            <ul class="multipage-menu">
                                <li class="menu-item">
                                    <a href="index">首页</a>

                                </li>
                                <!-- about menu -->
                                <li class="menu-item">
                                    <a href="products.html">产品中心</a>

                                </li>
                                <!-- page menu -->
                                <li class="menu-item-has-children">
                                    <a href="javascript:void(0)">解决方案</a>
                                    <ul class="submenu last-children">

                                        <li>
                                            <a href="solution1.html">有限空间作业智能管控方案</a>
                                        </li>

                                        <li>
                                            <a href="solution2.html">高处作业智能管控方案</a>
                                        </li>

                                    </ul>
                                </li>
                                <!-- elements menu -->
                                <li class="menu-item">
                                    <a href="case.html">客户案例</a>

                                </li>
                                <li class="menu-item">
                                    <a href="channelcooperation.html">渠道合作</a>

                                </li>
                                <li class="menu-item">
                                    <a href="aboutus.html">关于我们</a>

                                </li>
                                <li class="menu-item active">
                                    <a href="resourcecenter">资源中心</a>

                                </li>
                                <li class="menu-item ">
                                    <a href="news">新闻动态</a>

                                </li>
                                <li class="menu-item">
                                    <a href="contactus">联系我们</a>

                                </li>


                            </ul>
                        </nav>
                    </div>
                    <div class="rs-header-right">

                        <div class="rs-header-btn">
                            <a class="rs-btn has-theme-blue has-icon has-bg" href="contactus">立即体验
                                <span class="icon-box">
                                    <svg class="icon-first" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                    <svg class="icon-second" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path
                                            d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z">
                                        </path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                        <div class="rs-header-hamburger has-theme-blue">
                            <div class="sidebar-toggle">
                                <a class="bar-icon" href="javascript:void(0)" @click="toggleLayer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                        fill="none">
                                        <path
                                            d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                                            fill="#616161"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- Header area end -->


    <!-- Offcanvas area start -->
    <div class="fix" v-if="isShow">
        <div class="offcanvas-area has-theme-blue info-open" data-lenis-prevent>
            <div class="offcanvas-wrapper">
                <div class="offcanvas-content">
                    <div class="offcanvas-top d-flex justify-content-between align-items-center mb-25">
                        <div class="offcanvas-logo">
                            <a href="index"><img src="assets/images/logo/logo.png" alt="logo"></a>
                        </div>
                        <div class="offcanvas-close">
                            <button class="offcanvas-close-icon animation--flip" @click="toggleLayer">
                                <span class="offcanvas-m-lines">
                                    <span class="offcanvas-m-line line--1"></span><span
                                        class="offcanvas-m-line line--2"></span><span
                                        class="offcanvas-m-line line--3"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="offcanvas-about mb-30 d-none d-sm-block">
                        <p>北京大唐思拓信息技术有限公司成立于2006年。自创立之初，我们便坚定地投身于中国的安全生产管理事业。历经近二十年的深耕与发展，我们从最初的安全管理信息化系统研发与服务，逐步成长为今天集深厚行业经验与前沿AI技术于一体的国家级高新技术企业。我们是国内领先的人工智能与物联网（AIoT）解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                        </p>
                    </div>

                    <div class="mobile-menu mean-container">
                        <div class="mean-bar">
                            <nav class="mean-nav">
                                <ul class="multipage-menu">
                                    <li class="menu-item">
                                        <a href="index">首页</a>

                                    </li>
                                    <!-- about menu -->
                                    <li class="menu-item active">
                                        <a href="products.html" class="active">产品中心</a>

                                    </li>
                                    <!-- page menu -->
                                    <li class="menu-item">
                                        <a href="javascript:void(0)">解决方案</a>
                                        <ul class="submenu last-children">

                                            <li>
                                                <a href="solution1.html">有限空间作业智能管控方案</a>
                                            </li>

                                            <li>
                                                <a href="solution2.html">高处作业智能管控方案</a>
                                            </li>

                                        </ul>
                                        <a class="mean-expand" href="#" style="font-size: 18px"><i
                                                class="fa-regular fa-plus"></i></a>
                                    </li>
                                    <!-- elements menu -->
                                    <li class="menu-item">
                                        <a href="case.html">客户案例</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="channelcooperation.html">渠道合作</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="aboutus.html">关于我们</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="resourcecenter">资源中心</a>

                                    </li>
                                    <li class="menu-item">
                                        <a href="news">新闻动态</a>

                                    </li>
                                    <li class="menu-item mean-last">
                                        <a href="contactus">联系我们</a>

                                    </li>


                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="offcanvas-contact mb-30">
                        <h4 class="offcanvas-title-meta">联系我们</h4>
                        <ul>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-geo-alt-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="#">北京市西城区新街口外大街 28号C座 302 室 </a>
                                </div>
                            </li>
                            <li class="d-flex align-items-center gap-15">
                                <div class="offcanvas-contact-icon">
                                    <i class="bi bi-telephone-fill"></i>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="tel:400-6988-915">400-6988-915 </a>
                                </div>
                            </li>

                        </ul>
                    </div>
                    <div class="offcanvas-social">
                        <h4 class="offcanvas-title-meta">关注我们</h4>
                        <ul>
                            <li><a href="assets/images/weibo.jpg"> <img
                                        src="assets/images/weibo.jpg"><label>微博</label></a></li>
                            <li><a href="assets/images/bjh.jpg"><img src="assets/images/bjh.jpg"><label>百家号</label></a>
                            </li>
                            <li><a href="assets/images/code.jpg"><img
                                        src="assets/images/code.jpg"><label>微信公众号</label></a></li>
                            <li><a href="assets/images/douyin.jpg"><img
                                        src="assets/images/douyin.jpg"><label>抖音</label></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="offcanvas-overlay overlay-open"></div>
        <div class="offcanvas-overlay-white"></div>
    </div>

    <!-- Offcanvas area start -->

    <!-- Body main wrapper start -->
    <main class="homemain">

        <!-- breadcrumb area start -->
        <section class="rs-breadcrumb-area rs-breadcrumb-one p-relative">
            <div class="rs-breadcrumb-bg" style="background-image: url(assets/images/bg/breadcrumb-bg-01.png);"></div>
            <div class="container">
                <div class="row">
                    <div class="col-xxl-6 col-xl-8 col-lg-8">
                        <div class="rs-breadcrumb-content-wrapper">
                            <div class="rs-breadcrumb-title-wrapper">
                                <h1 class="rs-breadcrumb-title">资源中心</h1>
                            </div>
                            <div class="rs-breadcrumb-menu">
                                <nav>
                                    <ul>
                                        <li><span><a href="index">网站首页</a></span></li>
                                        <li><span>资源中心</span></li>

                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- breadcrumb area end -->

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-3" id="exampleModalLabel">请扫码获取</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p> <img src="assets/images/qywx.png" alt=""></p>
                    </div>

                </div>
            </div>
        </div>


        <!-- Modal -->
        <div class="modal fade application-modal" id="applicationModal" tabindex="-1"
            aria-labelledby="applicationModalLabel" aria-hidden="true" ref="applicationModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="applicationModalLabel">播放权限申请</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="handleApplicationSubmit">
                            <input type="hidden" id="videoId" name="videoId" :value="currentVideo?.id">
                            <div class="mb-3">
                                <label for="companyName" class="form-label">单位名称</label>
                                <input type="text" class="form-control" id="company" v-model="form.companyName"
                                    placeholder="请输入单位名称">
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="linkName" class="form-label">联系人 <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="linkName" v-model="form.linkName"
                                        required placeholder="请输入联系人">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="linkPhone" class="form-label">电话 <span
                                            class="text-danger">*</span></label>
                                    <input type="tel" class="form-control" id="linkPhone" v-model="form.linkPhone"
                                        required placeholder="请输入联系电话">
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="email" class="form-label">邮箱<span class="text-danger">*</span></label>
                                <input type="email" class="form-control" id="email" v-model="form.email"
                                    placeholder="请输入邮箱地址" required>
                            </div>
                            <div class="mb-3">
                                <label for="postName" class="form-label">担任职位</label>
                                <input type="tel" class="form-control" id="postName" v-model="form.postName"
                                    placeholder="请输入担任职位">
                            </div>
                            <div class="d-grid">
                                <button type="submit" class="btn submit-btn" style=" font-size: 18px;">提交申请</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- blog Style 03 -->
        <section class="rs-elements-blog-area section-space-bottom rs-blog-two videocenter">
            <div class="container">

                <div class="row">

                    <div class="col-xl-4 col-lg-4 videoside">
                        <div class="rs-sidebar-wrapper rs-sidebar-sticky">

                            <div class="sidebar-widget widget-categories-two mb-30">
                                <h5 class="sidebar-widget-title">视频分类</h5>
                                <div class="sidebar-widget-content">
                                    <div class="list">
                                        <ul v-for="category in childCategories" :key="category.id">
                                            <li>
                                                <a href="#" @click="handleTabChange(category.id)"> {{ category.name }}
                                                    <i class="ri-arrow-right-line"></i></a>
                                            </li>
                                        </ul>

                                        <!-- <ul>
                                            <li>
                                                <a href="#">
                                                    产品动态
                                                    <i class="ri-arrow-right-line"></i></a>
                                            </li>
                                        </ul> -->
                                    </div>
                                </div>
                            </div>
                            <div class="sidebar-widget mb-30 ">
                                <h5 class="sidebar-widget-title">热点视频</h5>
                                <div class="sidebar-widget-content">
                                    <div class="sidebar-blog-item-wrapper" v-for="top in hotList" :key="top.id">
                                        <div class="sidebar-blog-item">
                                            <div class="sidebar-blog-thumb">
                                                <a href="#" @click.prevent="handleVideoClick(top)">
                                                    <img :src="`${top.coverImage}`" alt="image">
                                                </a>
                                            </div>
                                            <div class="sidebar-blog-content">
                                                <h6 class="sidebar-blog-title">
                                                    <a href="#" @click.prevent="handleVideoClick(top)">{{
                                                        top.title}}</a>
                                                </h6>
                                                <div class="sidebar-blog-meta">
                                                    <i class="ri-calendar-line"></i>
                                                    <span>{{ top.stamp }}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-xl-8 col-lg-8">
                        <div class="row  g-5 justify-content-center section-title-space align-items-center">
                            <div class="col-xxl-8 col-xl-9 col-lg-9">
                                <div class="rs-section-title-wrapper text-center">
                                    <h2 class="rs-section-title rs-split-text-enable split-in-fade">视频中心</h2>
                                </div>
                            </div>
                        </div>
                        <div class="row g-5">
                            <div class="col-xl-4 col-lg-6 col-md-6 videolist" v-for="item in resourceList"
                                :key="item.id">
                                <div class="rs-blog-item">
                                    <div class="rs-blog-thumb">
                                        <a :href="item.content" @click.prevent="handleVideoClick(item)"
                                            class="popup-video">
                                            <img :src="`${item.coverImage}`" alt="">
                                        </a>
                                    </div>
                                    <div class="rs-blog-content">
                                        <div class="rs-blog-tag has-theme-red">
                                            <a href="#">时长：{{ getItemDuration(item) }}</a>
                                        </div>
                                        <h5 class="rs-blog-title underline has-black" @click="handleVideoClick(item)">
                                            {{ item.title }}
                                        </h5>
                                        <div class="rs-blog-meta">
                                            <div class="rs-blog-meta-item">
                                                <span><a class="rs-blog-meta-author" href="#"> {{ item.publishUser
                                                }}</a>
                                                </span>
                                            </div>
                                            <div class="rs-blog-meta-item">
                                                <span>{{ item.stamp }}</span>
                                            </div>
                                        </div>
                                        <div class="rs-blog-btn-wrapper">
                                            <span class="rs-blog-meta-text">已播放 {{ item.viewCount }} 次</span>
                                            <a class="popup-video rs-play-btn" :href="item.content"
                                                @click.prevent="handleVideoClick(item)">
                                                <span class="icon-box"><i class="bi bi-play-circle-fill"></i></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>




                <!-- pagination style -->
                <div class="row">
                    <div class="col-xl-12">
                        <div class="pagination-wrapper mt-40">
                            <div class="common-pagination text-center" v-if="pageList.totalPageCount > 1">
                                <nav>
                                    <ul>
                                        <li v-for="index in pageList.totalPageCount" :key="index"
                                            :class="{ active: pageList.current === index }"
                                            @click.prevent="getResourceList(fileType, index,pageList.childFileType)">
                                            <a class="current" href="#">{{ index }}</a>
                                        </li>
                                        <li>
                                            <a class="page-link" href="#" @click.prevent="goToNextPage()"> → </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- pagination style end -->
            </div>
        </section>
        <!-- blog Style 03 -->




        <!-- team area start -->
        <section class="rs-team-area section-space-bottom rs-team-one has-theme-blue qt">
            <div class="container">
                <div class="row  g-5 justify-content-center align-items-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="rs-section-title-wrapper text-center section-title-space">

                            <h2 class="rs-section-title has-theme-blue rs-split-text-enable split-in-fade">其他资料</h2>
                        </div>
                    </div>
                </div>
                <div class="row g-5">

                    <div class="col-xl-4 col-lg-4 col-md-4" v-for="item in otherList" :key="item.id">
                        <div class="rs-team-item wow fadeInUp" data-wow-delay=".3s" data-wow-duration="1s">
                            <div class="rs-team-thumb has-clip">
                                <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <!-- <img src="assets/images/qt1.jpg" alt="image"> -->
                                    <img :src="`${item.coverImage}`" alt="">
                                </a>

                            </div>
                            <div class="rs-team-content-wrapper">
                                <div class="rs-team-content-box">
                                    <h5 class="rs-team-title"><a href="#" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal">{{ item.title }}</a></h5>
                                    <span class="rs-team-designation"><button type="button"
                                            class="btn btn-primary btn-lg" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal">立即获取</button></span>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
        <!-- team area end -->



        <!-- 视频播放模态框 -->
        <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="videoModalLabel">{{ currentVideo?.title || '视频播放' }} </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body p-0">
                        <video ref="videoPlayer" :src="currentVideoUrl" controls
                            style="width: 100%;height:400px;object-fit: contain;background-color: #000;"></video>
                    </div>
                </div>
            </div>
        </div>



    </main>
    <!-- Body main wrapper end -->
    <div class="rs-footer-bg-thumb-wrapper">
        <div class="rs-footer-bg-thumb" data-background="assets/images/bg/footer-bg-02.png"></div>



        <!-- Body main wrapper end -->

        <!-- footer area start -->
        <footer>
            <div class="rs-footer-area rs-footer-two has-theme-blue">
                <div class="container">
                    <div class="rs-footer-top">
                        <div class="row g-5">
                            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-1">
                                    <h5 class="rs-footer-widget-title">关于我们</h5>
                                    <div class="rs-footer-widget-content">
                                        <img src="assets/images/logo/logo1.png" style="height: 60px;" alt="">
                                        <p class="rs-footer-widget-description">
                                            智能守护安全，创新引领未来，20年的深耕与发展，领先的人工智能与物联网(AIoT)解决方案提供商，更是您值得信赖的、懂业务的资深安全伙伴。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <div class="rs-footer-widget footer-2-col-2">
                                    <h5 class="rs-footer-widget-title">产品与服务</h5>
                                    <div class="rs-footer-widget-content">
                                        <div class="rs-footer-widget-links has-theme-blue">
                                            <ul>
                                                <li> <a href="products.html">产品中心</a> </li>
                                                <li><a href="solution1.html">解决方案</a></li>
                                                <li><a href="case.html">客户案例</a></li>
                                                <li><a href="channelcooperation.html">寻求合作</a></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-6">
                                <h5 class="rs-footer-widget-title">支持与资源</h5>
                                <div class="rs-footer-widget-content">
                                    <div class="rs-footer-widget-links has-theme-blue">
                                        <ul>

                                            <li> <a href="news">新闻中心</a> </li>
                                            <li><a href="resourcecenter">获取资源</a></li>
                                            <li><a href="contactus">联系我们</a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-6">
                                <div class="rs-footer-widget">
                                    <h5 class="rs-footer-widget-title">关注我们</h5>
                                    <div class="rs-footer-widget-content">

                                        <p class="rs-footer-widget-description" style="margin-bottom: 10px;">
                                            关注我们的社交媒体了解更多信息
                                        </p>
                                        <div class="rs-footer-widget-social">
                                            <div class="rs-theme-social has-theme-blue">
                                                <a href="assets/images/weibo.jpg"> <img
                                                        src="assets/images/weibo.jpg"><label>微博</label></a>
                                                <a href="assets/images/bjh.jpg"><img
                                                        src="assets/images/bjh.jpg"><label>百家号</label></a>
                                                <a href="assets/images/code.jpg"><img
                                                        src="assets/images/code.jpg"><label>微信公众号</label></a>
                                                <a href="assets/images/douyin.jpg"><img
                                                        src="assets/images/douyin.jpg"><label>抖音</label></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rs-footer-copyright-area rs-copyright-one">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-8">
                                <div class="rs-footer-copyright has-theme-blue text-left">
                                    <p class="underline"> 版权所有 © <span id="year">2025</span> <a
                                            href="http://www.datascore.com" target="_blank">北京大唐思拓信息技术有限公司</a></p>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div style="text-align: right; color: #fff;"> <a href="https://beian.miit.gov.cn/"
                                        target="_blank">京ICP备19044307号</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- footer area end -->

    </div>


    <!-- back to top -->
    <!-- Backtotop start -->
    <div class="backtotop-wrap cursor-pointer" @click="scrollToTop">
        <svg class="backtotop-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>

</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import http from '@/shared/http.service';
import { Uris } from '@/shared/const';
import dayjs from 'dayjs';
import useClue from '@/composables/useClue';
import useResource from '@/composables/useResource';
onMounted(() => {
    document.title = '高危作业智能哨兵 - 智能安全专家 | 安全生产智能管控平台 | 安全生产管理系统 | 智慧电厂解决方案';

    const metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    metaKeywords.content = '高危作业智能哨兵,智能安全专家，安全生产智能管控平台,安全生产，安全管理，生产管理系统，安全生产管理，智能工厂，电厂生产管理系统，智慧电厂';
    document.head.appendChild(metaKeywords);

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = '高危作业智能哨兵，智能安全专家，专注于安全生产智能管控平台建设，提供覆盖安全生产管理、智能工厂、电厂生产管理系统的全方位解决方案，助力企业实现智慧电厂的高效、安全运营。';
    document.head.appendChild(metaDescription);

});

// 响应式数据
const currentVideoUrl = ref('');
const videoPlayer = ref(null);
const currentVideo = ref(null);
const resourceList = ref([]);
const otherList = ref([]); // 其他资料列表
const pageList = ref({ totalPageCount: 1, current: 1 });
const pageOtherList = ref({ totalPageCount: 1, current: 1 }); // 其他资料分页数据
const fileType = ref(1);
const videoDurations = ref({});
const approvedVideos = ref([]);

// 模态框实例
let videoModalInstance = null;
let applicationModalInstance = null;

// 使用线索管理
const {
    form,
    handleSave,
    resetFields
} = useClue();

const {

    childCategories,
    fetchChildCategories
} = useResource();


// 生命周期
onMounted(() => {
    fetchChildCategories();
    initializeModals();
    loadApprovedVideos();
    getResourceList(1, 1); // 获取视频列表
    getResourceList(2, 1); // 获取其他资料列表
    getHotList();
});

onUnmounted(() => {
    // 清理模态框实例
    if (videoModalInstance) {
        videoModalInstance.dispose();
    }
    if (applicationModalInstance) {
        applicationModalInstance.dispose();
    }
});

const categoryName = ref();
// 监听分类切换
const handleTabChange = (key) => {
    // activeCategory.value = key;
    categoryName.value = childCategories.value.filter(t => t.id == key)[0].name;
    getResourceList(1, 1, key);
};

const hotList = ref([]);
// 获取热点新闻列表
const getHotList = async () => {
    // 由于新闻列表是push添加的，每次切换分类都需要先清空列表
    hotList.value = [];
    try {
        const response = await http.get(Uris.ResourceList, {
            pageIndex: 1, pageSize: 4, isFront: 1, orderBy: 'viewCount', direction: 'Desc'
        }).subscribe(t => {
            const { list, totalCount, totalPageCount, pageIndex, pageSize } = t;
            t.list.forEach(element => {
                const model = {
                    id: element.id,
                    title: element.title,
                    stamp: dayjs(element.stamp).format('YYYY-MM-DD'),
                    viewCount: element.viewCount,
                    publishUser: element.publishUser,
                    coverImage: `${window.serverConfig?.baseUrl || ''}/${element.coverImage}`,
                    content: `${window.serverConfig?.baseUrl || ''}/${element.content}`,
                };
                hotList.value.push(model);
            });

        });

    } catch (error) {
        console.error('获取新闻列表失败:', error);
    }
};

// 初始化模态框
const initializeModals = () => {
    // 视频播放模态框
    const videoModalElement = document.getElementById('videoModal');
    if (videoModalElement) {
        videoModalInstance = new window.bootstrap.Modal(videoModalElement, {
            backdrop: 'static',
            keyboard: false
        });

        // 监听关闭事件
        videoModalElement.addEventListener('hidden.bs.modal', () => {
            pauseVideo();
        });
    }

    // 申请模态框
    const applicationModalElement = document.getElementById('applicationModal');
    if (applicationModalElement) {
        applicationModalInstance = new window.bootstrap.Modal(applicationModalElement, {
            backdrop: 'static',
            keyboard: false
        });
    }
};

// 视频权限管理
const loadApprovedVideos = () => {
    const saved = localStorage.getItem('approvedVideos');
    if (saved) {
        try {
            approvedVideos.value = JSON.parse(saved);
        } catch (e) {
            console.error('解析已批准视频列表失败:', e);
            approvedVideos.value = [];
        }
    }
};

const saveApprovedVideos = () => {
    localStorage.setItem('approvedVideos', JSON.stringify(approvedVideos.value));
};

const isVideoApproved = (videoId) => {
    // 如果有特殊标识，所有视频都可看
    if (approvedVideos.value.includes('ALL_APPROVED')) {
        return true;
    }
    // 否则按原逻辑检查特定视频
    return approvedVideos.value.includes(videoId);
};

// 视频点击处理
const handleVideoClick = (item) => {
    // console.log('点击视频:', item);
    currentVideo.value = item;
    currentVideoUrl.value = item.content;
    form.title = item.title;
    form.centerId = item.id;
    form.source = "视频中心";
    addViewCount(item.id);
    if (isVideoApproved(item.id)) {
        playVideo(item);

    } else {
        showApplicationModal(item);
    }
};

const showApplicationModal = (item) => {
    currentVideo.value = item;
    currentVideoUrl.value = item.content;
    if (applicationModalInstance) {
        applicationModalInstance.show();
    }
};

// 申请表单提交
const handleApplicationSubmit = async () => {
    try {
        // 准备表单数据
        const formData = {
            ...form,
            videoId: currentVideo.value?.id,
            videoTitle: currentVideo.value?.title
        };


        // 调用保存方法
        await handleSave(formData);

        // 关键修改：使用特殊标识批准所有视频
        if (!approvedVideos.value.includes('ALL_APPROVED')) {
            approvedVideos.value = ['ALL_APPROVED'];
            saveApprovedVideos();
        }

        // 关闭申请模态框
        if (applicationModalInstance) {
            applicationModalInstance.hide();
        }

        // 重置表单
        resetFields();

        // 播放视频
        playVideo(currentVideo.value);

    } catch (error) {
        console.error('提交申请失败:', error);
        alert('提交失败，请重试');
    }
};

// 视频播放控制
const playVideo = (item) => {
    currentVideo.value = item;
    currentVideoUrl.value = item.content;

    if (videoModalInstance) {
        videoModalInstance.show();

        // 延迟播放确保视频加载
        nextTick(() => {
            setTimeout(() => {
                if (videoPlayer.value) {
                    videoPlayer.value.play().catch(err => {
                        console.log('自动播放失败，需要用户交互:', err);
                    });
                }
            }, 500);
        });
    }
};

const closeVideoModal = () => {
    if (videoModalInstance) {
        videoModalInstance.hide();
    }
};

const pauseVideo = () => {
    if (videoPlayer.value) {
        videoPlayer.value.pause();
    }
};

// 数据获取
const getResourceList = async (type, page, childType) => {
    try {
        if (type === 1) {
            resourceList.value = []; // 清空视频列表
        } else if (type === 2) {
            otherList.value = []; // 清空其他资料列表
        }
        

        const response = await http.get(Uris.ResourceList, {
            fileType: type,
            childFileType: childType,
            pageIndex: page,
            pageSize: 9,
            isFront: 1
        }).subscribe(data => {
            const { list, totalCount, totalPageCount, pageIndex, pageSize } = data;

            list.forEach(element => {
                const model = {
                    id: element.id,
                    title: element.title,
                    stamp: dayjs(element.stamp).format('YYYY-MM-DD'),
                    viewCount: element.viewCount,
                    publishUser: element.publishUser,
                    coverImage: `${window.serverConfig?.baseUrl || ''}/${element.coverImage}`,
                    content: `${window.serverConfig?.baseUrl || ''}/${element.content}`,
                };

                if (type === 1) {
                    resourceList.value.push(model);
                } else if (type === 2) {
                    otherList.value.push(model);
                }
            });

            if (type === 1) {
                pageList.value = {
                    totalPageCount: totalPageCount,
                    current: pageIndex,
                    childFileType: childType
                };

                // 加载视频时长
                loadVideoDurations();
            } else if (type === 2) {
                pageOtherList.value = {
                    totalPageCount: totalPageCount,
                    current: pageIndex
                };
            }
        });

    } catch (error) {
        console.error('获取资源列表失败:', error);
    }
};

// 分页操作
const goToNextPage = () => {
    if (pageList.value.current < pageList.value.totalPageCount) {
        getResourceList(fileType.value, pageList.value.current + 1);
    }
};

// 视频时长处理
const getVideoDuration = (videoUrl, itemId) => {
    return new Promise((resolve) => {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.addEventListener('loadedmetadata', () => {
            const duration = video.duration;
            resolve(duration);
        });
        video.addEventListener('error', () => {
            console.warn(`无法加载视频: ${videoUrl}`);
            resolve(0);
        });
    });
};

const loadVideoDurations = async () => {
    for (const item of resourceList.value) {
        if (!videoDurations.value[item.id]) {
            try {
                const duration = await getVideoDuration(item.content, item.id);
                videoDurations.value[item.id] = duration;
            } catch (error) {
                console.warn(`获取视频时长失败: ${item.id}`, error);
                videoDurations.value[item.id] = 0;
            }
        }
    }
};

const formatDuration = (seconds) => {
    if (!seconds || seconds === 0) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const getItemDuration = (item) => {
    const duration = videoDurations.value[item.id];
    return formatDuration(duration);
};


// 添加点击量
const addViewCount = async (resourceId) => {
    try {
        const response = await http.post(Uris.AddViewCount, { resourceId: resourceId }).subscribe(t => {
            console.log(t);

        }); // 调用后台接口


    } catch (error) {
        // console.error('获取新闻分类失败:', error);
    }
};

// 滚动到顶端的方法
const scrollToTop = () => {
    // 方法1：使用 window.scrollTo() 带平滑动画
    window.scrollTo({
        top: 0, // 滚动到顶部
        behavior: 'smooth' // 平滑滚动（关键）
    });

    // 方法2：兼容旧浏览器（手动设置滚动距离，无动画）
    // document.documentElement.scrollTop = 0
    // document.body.scrollTop = 0
};
</script>

<style lang="less">
.rs-blog-two .rs-blog-content {
    position: relative;
    background: var(--rs-bg-primary);
    padding: 30px 30px 30px 30px;
}

@media only screen and (max-width: 1199px) {
    .rs-blog-two .rs-blog-content {
        padding: 20px 20px 20px 20px;
    }
}

.rs-postbox-item:not(:last-child) {
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
    padding-bottom: 20px;
}

@media only screen and (max-width: 575px) {
    .rs-postbox-item:not(:last-child) {
        margin-bottom: 20px;
        padding-bottom: 20px;
    }
}

.rs-postbox-content {
    padding-top: 20px;
}

.video-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    margin-bottom: 25px;
    height: 100%;
}

.video-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.video-thumb {
    position: relative;
    overflow: hidden;
    height: 200px;
}

.video-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
}

.video-card:hover .video-thumb img {
    transform: scale(1.05);
}

.play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.video-card:hover .play-overlay {
    opacity: 1;
}

.play-btn {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2575fc;
    font-size: 24px;
    transition: all 0.3s ease;
}

.play-btn:hover {
    background: white;
    transform: scale(1.1);
}

.video-content {
    padding: 20px;
}

.video-title {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 10px;
    color: #333;
    line-height: 1.4;
    cursor: pointer;
    transition: color 0.2s;
}

.video-title:hover {
    color: #2575fc;
}

.video-meta {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    color: #666;
    margin-bottom: 15px;
}

.video-tag {
    display: inline-block;
    background: #ff6b6b;
    color: white;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 0.8rem;
    margin-bottom: 10px;
}

.video-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}

.view-count {
    color: #666;
    font-size: 0.85rem;
}

.application-modal .modal-content {
    border-radius: 15px;
    overflow: hidden;
    border: none;
}

.application-modal .modal-header {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border-bottom: none;
}

.application-modal .modal-title {
    font-weight: 600;
}

.application-modal .btn-close {
    filter: invert(1);
}

.application-modal .form-control {
    border-radius: 8px;
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    transition: all 0.3s;
}

.application-modal .form-control:focus {
    border-color: #2575fc;
    box-shadow: 0 0 0 0.2rem rgba(37, 117, 252, 0.25);
}

.submit-btn {

    /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
    border: none;
    padding: 12px 30px;
    border-radius: 30px;
    font-weight: 600;
    transition: all 0.3s;
}

.submit-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(37, 117, 252, 0.4);
}

.status-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #28a745;
    color: white;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    z-index: 2;
}

.video-player {
    background: #000;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 20px;
}

.player-header {
    background: #333;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.player-content {
    padding: 20px;
    text-align: center;
    color: #666;
}

.empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #666;
}

.empty-state i {
    font-size: 3rem;
    margin-bottom: 15px;
    color: #ccc;
}

.rs-blog-thumb img {
    height: 200px !important;
    width: 100%;
    object-fit: cover;
}

.has-clip img {
    height: 400px !important;
    width: 100%;
    object-fit: cover;
}

.videocenter {
    margin-top: 50px;
}

.rs-blog-two .videolist .rs-blog-content {
    cursor: pointer;
    padding: 20px !important;
}

.videoside .sidebar-blog-title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 显示两行 */
    -webkit-box-orient: vertical;
}


.rs-blog-two .videolist .rs-blog-title {
    white-space: nowrap;
}
</style>